import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/Spinner.svg'
import _imports_1 from '@/assets/icons/LogoDH.svg'


const _hoisted_1 = { class: "container-spinner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "spinner"
    }, null, -1),
    _createElementVNode("img", {
      src: _imports_1,
      alt: "",
      class: "logo"
    }, null, -1)
  ]))]))
}